import { get, post } from 'app/shared/utils/fetchr';

export const getComments = (articleId: number) => get(`/comments/${articleId}`);

export const addComment = ({ articleId, details }) =>
  post(`/comments/${articleId}/add`, details);
